"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DND_FILE_LIST_ITEM_TYPE = void 0;
var _react = require("@chakra-ui/react");
var _reactDnd = require("react-dnd");
var _jsxRuntime = require("react/jsx-runtime");
const DND_FILE_LIST_ITEM_TYPE = 'row';
exports.DND_FILE_LIST_ITEM_TYPE = DND_FILE_LIST_ITEM_TYPE;
const TableRow = props => {
  const blueBgColor = (0, _react.useColorModeValue)('blue.100', 'blue.400');
  const [, drop] = (0, _reactDnd.useDrop)({
    accept: DND_FILE_LIST_ITEM_TYPE,
    drop(item, monitor) {
      //monitor.isOver({shallow: false})
      props.onDnD(item.index, props.index);
    }
  });
  const [{
    isDragging
  }, drag] = (0, _reactDnd.useDrag)({
    type: DND_FILE_LIST_ITEM_TYPE,
    item: {
      type: DND_FILE_LIST_ITEM_TYPE,
      index: props.index
    },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  });
  const opacity = isDragging ? 0 : 1;
  const dndRefs = el => {
    drag(el);
    drop(el);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Tr, {
    ref: dndRefs,
    style: {
      opacity
    },
    fontSize: "sm",
    bg: props.isSelected ? blueBgColor : undefined,
    onClick: e => props.onClick(e, props.index),
    onDoubleClick: e => props.onDoubleClick(e, props.index),
    onContextMenu: e => props.onContextMenu(e, props.index),
    children: props.row.cells.map(cell => {
      const cellElement = cell.render('Cell');
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Td, {
        ...cell.getCellProps(),
        isNumeric: cell.column.isNumeric,
        children: cellElement
      });
    })
  });
};
var _default = TableRow;
exports.default = _default;